<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page.sync="page"
    :page-size="pageSize"
    background
    :pager-count="5"
    :page-sizes="[25, 50, 100]"
    :total="totalNum"
    layout="total, sizes, prev, pager, next"
  ></el-pagination>
</template>
<script>

export default {
  name: "Pagination",
  props: {
    currentChange: Function,
    sizeChange: Function,
    totalNum: { type: Number, default: 0 },
    pageSize: { type: [Number, String], default: 25 },
    currentPage: { type: [Number, String], default: 1 },
  },
  data() {
    return {
      page: 1
    };
  },
  methods: {
    handleSizeChange(val) {
      this.sizeChange(val);
    },
    handleCurrentChange(val) {
      this.currentChange(val);
    }
  },
  watch: {
    currentPage() {
      this.page = this.currentPage;
    }
  }
};
</script>
